var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5383",
    "data-name": "Group 5383",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.633,
    height: 14.105,
    viewBox: "0 0 17.633 14.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M15.677,49.214a.648.648,0,0,0-.918,0l-2.3,2.3a8.823,8.823,0,0,0-8.8.918,14.708,14.708,0,0,0-3.53,3.26.653.653,0,0,0,.018.792,15.91,15.91,0,0,0,3.836,3.508L1.953,62.02a.648.648,0,1,0,.914.918l12.81-12.807A.652.652,0,0,0,15.677,49.214ZM7.213,56.76a1.685,1.685,0,0,1-.14-.684,1.744,1.744,0,0,1,2.429-1.6Zm3.246-3.242a3.036,3.036,0,0,0-4.2,4.2L4.928,59.048a13.628,13.628,0,0,1-3.44-2.983,13.86,13.86,0,0,1,2.875-2.548,7.551,7.551,0,0,1,7.107-1.011Z",
    transform: "translate(0 -49.023)",
    fill: "#878a99"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(6.501 3.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M191.653,156.395a17.348,17.348,0,0,0-2.746-2.746.65.65,0,1,0-.8,1.022,15.472,15.472,0,0,1,2.2,2.141,14.2,14.2,0,0,1-2.375,2.206,8,8,0,0,1-6.488,1.688.647.647,0,1,0-.266,1.267,8.064,8.064,0,0,0,1.684.176,8.562,8.562,0,0,0,2.558-.4,11.424,11.424,0,0,0,3.307-1.709,14.861,14.861,0,0,0,2.943-2.854A.653.653,0,0,0,191.653,156.395Z",
    transform: "translate(-180.663 -153.512)",
    fill: "#878a99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.59ea08379be563a89606fe7597519213.svg";
export { ForwardRef as ReactComponent };